import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const PeopleFillIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`People Fill`} {...props}>
    <Path
      fill="currentColor"
      d="M10 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM5 12.037a3.205 3.205 0 0 1 3.205-3.205h3.59A3.205 3.205 0 0 1 15 12.037c0 .531-.43.962-.962.962H5.962A.962.962 0 0 1 5 12.037Z"
    />
    <Path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.537 6.942A3.739 3.739 0 0 1 6.25 5.5c0-1.169.535-2.213 1.374-2.901a2.5 2.5 0 1 0-1.086 4.343Zm.193.89H4.205A3.205 3.205 0 0 0 1 11.037c0 .531.43.962.962.962H3.75a4.457 4.457 0 0 1 2.98-4.167Z"
      clipRule="evenodd"
    />
  </Icon>
);
